import script from "./PlIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./PlIcon.vue?vue&type=script&setup=true&lang=js"

import "./PlIcon.vue?vue&type=style&index=0&id=1335616e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1335616e"]])

export default __exports__